import { createSlice } from "@reduxjs/toolkit";
import {
	setCustomerData,
	removeCustomerData,
	getCustomerData,
} from "../../lib/useLocalStorageCustomer";

const customerData = getCustomerData();
const initialState = customerData ? customerData : null;

const customerSlice = createSlice({
	name: "customer",
	initialState: initialState,
	reducers: {
		getCustomer(state, action) {
			const customerData = getCustomerData();
			return { ...state, ...customerData };
		},
		setCustomer(state, action) {
			const customerData = action.payload;
			setCustomerData(customerData);
			return {
				...state,
				...customerData,
			};
		},
		removeCustomer(state, action) {
			removeCustomerData();
			return {
				...state,
				...null,
			};
		},
	},
});

export const {
	getCustomer,
	setCustomer,
	removeCustomer,
} = customerSlice.actions;

export default customerSlice.reducer;
